import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

class DatePicker {
    constructor() {
        this.init();

        // CF7 AJAX lifecycle
        document.addEventListener("wpcf7mailsent", this.init);
        document.addEventListener("wpcf7invalid", this.init);
        document.addEventListener("wpcf7reset", this.init);
    }

    init = () => {
        const startInput = document.querySelector('input[name="start-date"]');
        const endInput   = document.querySelector('input[name="end-date"]');

        if (!startInput || !endInput) return;

        // Ako već postoje, ne dupliraj
        if (startInput._flatpickr && endInput._flatpickr) return;

        const startPicker = flatpickr(startInput, {
            dateFormat: "d.m.Y",
            allowInput: true,
            disableMobile: true,
            onChange: (selectedDates) => {
                if (!selectedDates.length) return;

                endPicker.set('minDate', selectedDates[0]);

                // ako je end već izabran, ali je manji – resetuj ga
                if (
                    endInput.value &&
                    endPicker.selectedDates[0] < selectedDates[0]
                ) {
                    endPicker.clear();
                }
            }
        });

        const endPicker = flatpickr(endInput, {
            dateFormat: "d.m.Y",
            allowInput: true,
            disableMobile: true
        });
    };

}

export default DatePicker;
